import { render, staticRenderFns } from "./Fund-Header.vue?vue&type=template&id=05110218&scoped=true&"
import script from "./Fund-Header.vue?vue&type=script&lang=js&"
export * from "./Fund-Header.vue?vue&type=script&lang=js&"
import style0 from "./Fund-Header.vue?vue&type=style&index=0&id=05110218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05110218",
  null
  
)

export default component.exports